import React, { ReactElement } from 'react'
import { dateFormats } from '@mindfulchefuk/lib/dateFormats'
import { Flex, Icon, Text } from '@mindfulchefuk/design-system'
import { CloseButton } from '@mindfulchefuk/features/Cart/components/CartDrawer/CartDrawerWrapper'

type Props = {
  deliveryDate: Date
  onClose: (event: React.MouseEvent<HTMLElement>) => void
}

export const OnboardingCartDrawerHeader = ({
  deliveryDate,
  onClose,
}: Props): ReactElement => {
  const formattedDate = dateFormats.fullWeekdayAbbvMonthDay(deliveryDate)

  return (
    <Flex
      justifyContent="space-between"
      alignItems="center"
      borderColor="pepper-50"
      borderBottomWidth={1}
      paddingY={{ base: 12, sm: 24 }}
      paddingX={24}
    >
      <Text
        as="h3"
        variant="heading-sm"
        color="aubergine"
        data-testid="cart-drawer-header-title"
      >
        {`Order for delivery on ${formattedDate}`}
      </Text>
      <Flex
        height="100%"
        alignItems={{ base: 'flex-start', sm: 'center' }}
        flexDirection="column"
      >
        <CloseButton
          data-testid="cart-drawer-close-button"
          whileTap={{ scale: 0.9 }}
          onClick={onClose}
        >
          <Icon type="cross" size={16} color="aubergine" />
        </CloseButton>
      </Flex>
    </Flex>
  )
}
